// store is based on : https://stenciljs.com/docs/stencil-store
// Note: Proxy objects are not supported by IE11 (not even with a polyfill),
// so we need to use the store.get and store.set methods of the API.

// before creating the store we initialize AppInsights
import { createStore } from '@stencil/store';

import Logger from '../utils/logger/logger';
import { defaultStoreValues } from './defaultState';
import { setLocaleSideEffect } from './sideEffects/locale';
import { setModeSideEffect } from './sideEffects/mode';
import { setThemeSideEffect } from './sideEffects/theme';

const store = createStore(defaultStoreValues);

store.on('set', (key, newValue, oldValue) => {
    // Used to check hydration
    Logger.debug('store', `key: ${key}\noldValue: ${JSON.stringify(oldValue)} \nnewValue: ${JSON.stringify(newValue)} \n`, { state: store.state });
});

setModeSideEffect(store);
setThemeSideEffect(store);
setLocaleSideEffect(store);

export default store;
